import * as React from 'react';
import { cn } from '@shadcn/lib/utils';

interface ToastProps {
  message: string;
  visible: boolean;
  onClose: () => void;
}

const Toast: React.FC<ToastProps> = ({ message, visible, onClose }) => {
  if (!visible) return null;

  return (
    <div className={cn('fixed bottom-4 right-4 bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4 shadow-lg')} role="alert">
      <div className="flex justify-between items-center">
        <span>{message}</span>
        <button onClick={onClose} className="ml-4 text-yellow-700 hover:text-yellow-900">&times;</button>
      </div>
    </div>
  );
};

export default Toast;
